var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"lds-dual-ring",class:{'hidden': !_vm.loading}},[_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div')])
}
var staticRenderFns = []

export { render, staticRenderFns }